import { Component, computed, DestroyRef, inject, input, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, Scroll } from '@angular/router';
import { Permissions } from '@p2p/access-control/domain';
import { NotificationsApiService } from '@p2p/notifications/api';
import { SvgIcons } from '@p2p/shared/svg-icon';
import { filter, map } from 'rxjs';

import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit {
    readonly SvgIcons = SvgIcons;
    readonly Permissions = Permissions;
    readonly activeRoutes = {
        users: 'users',
        dashboards: 'dashboards',
        platformSettings: 'platform-settings',
        disputes: 'disputes',
        payment: 'payment',
        team: 'team',
        api: 'api',
        notifications: 'notifications'
    };

    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);
    private readonly notificationsApiService = inject(NotificationsApiService);
    private readonly menuService = inject(MenuService);

    readonly notificationsUnreadCount = toSignal(this.notificationsApiService.unreadCount$);
    readonly isMenuOpened = signal(false);

    currentUrl = '';

    ngOnInit(): void {
        this.subscribeRouterEvents();

        this.notificationsApiService.loadUnreadCount();
        this.notificationsApiService.startUnreadCountPolling();

        this.menuService.openMenuEvent$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.isMenuOpened.set(true);
        });
    }

    closeMenu(): void {
        if (this.isMenuOpened()) {
            this.isMenuOpened.set(false);
        }
    }

    private subscribeRouterEvents(): void {
        this.router.events
            .pipe(
                map((event) => {
                    if (event instanceof NavigationEnd) {
                        return event;
                    }

                    if (event instanceof Scroll && event.routerEvent instanceof NavigationEnd) {
                        return event.routerEvent;
                    }
                }),
                filter((event) => !!event),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe((event) => {
                this.currentUrl = event.url;
                this.closeMenu();
            });
    }
}
